import { render, staticRenderFns } from "./CommissionAgreementPreview.vue?vue&type=template&id=5d0a8768&scoped=true&"
import script from "./CommissionAgreementPreview.vue?vue&type=script&lang=js&"
export * from "./CommissionAgreementPreview.vue?vue&type=script&lang=js&"
import style0 from "./CommissionAgreementPreview.vue?vue&type=style&index=0&id=5d0a8768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a8768",
  null
  
)

export default component.exports